import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import route from '../../utils/Routes';
import { useAuthContext } from '../../context/AuthContext';
import constants from '../../utils/Constants';

function PoLinkPage() {
    const { ctxtUser, setLoadingScreen } = useAuthContext();
    const navigate = useNavigate();
    const { poId } = useParams();

    useEffect(() => {
        setLoadingScreen(true);
        if (poId) {
            if (ctxtUser?.isComUser) {
                if (ctxtUser?.userType === constants.approver) {
                    navigate(`${route.cPoTracking}`);
                } else {
                    navigate(`${route.cPoInfo}/?poId=${poId}`);
                }
            }
            else {
                navigate(`${route.aPoInfo}/?poId=${poId}`);
            }
        } else {
            navigate(route.login, { replace: true });
        }
        setLoadingScreen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (<div>PoLinkPage</div>)
}

export default PoLinkPage
